﻿import { Component, EventEmitter, Output } from "@angular/core";
import { ActivatedRoute,Router } from "@angular/router";
import { HashLocationStrategy, Location, LocationStrategy, CommonModule } from "@angular/common";
import { SearchCases } from "../models/searchcasesfilter.model";
import { DataService } from "../services/dataService";
import { Modal } from "../shared/dialog/dialog.component";
import { ModalService } from "../shared/dialog/dialog.service";
import { UploadDocumentComponent } from "./uploaddocument.component";

@Component({
    selector: "jax-externalusercasescomponent",
    templateUrl: "./externalUserCases.component.html",
})


export class ExternalUserCasesComponent {
    public data;
    public filterQuery = "";
    public rowsOnPage = 10;
    public sortBy = "FirstName";
    public totalRecord = 0;
    public sortOrder = "asc";
    public isCompleted = false;
    public hasError = false;
    public errorMessage: string;
    public searchcase: SearchCases = new SearchCases();
    public currentUser: any;
    private MODAL_ID: string;
    private currentCaseDisplayNumber: string;
    public isCaseSevered: boolean = false;

    public searchFields: CaseSearchFields[] = new Array();
    public searchFieldId: string = "";

    constructor(private route: ActivatedRoute, private dataService: DataService, private router: Router, private modalService: ModalService) {
        this.currentUser = JSON.parse(localStorage.getItem("currentUser"));
        if (this.currentUser) {
            this.searchcase.UserID = this.currentUser.UserId;
        }
        this.MODAL_ID = "uploaddocument";
    }

    public onSelectCase(caseNumber: string, caseId: number, roleId: number,caseType:string) {

        this.isCaseSevered = false;

        this.isCaseSevered = this.data.some(c => c.CaseID === caseId && c.IsSeveranceCase == true);

        if (this.isCaseSevered) {
            return;
        }

        if (caseNumber) {
            this.router.navigate(["../casedetail"], { relativeTo: this.route, queryParams: { CaseNumber: caseNumber, CaseID: caseId, RoleID: roleId, CaseType:caseType}, skipLocationChange: true  });
        }
    }

    public ngOnInit() {
        this.isCompleted = false;

        //this.searchcase.FirstName = "Crystal";
        //this.searchcase.LastName = "Roberts";
        this.dataService.get("Cases/externalusercases?UserId=" + this.searchcase.UserID).subscribe(
        //this.dataService.post("Cases/externalusercases", JSON.stringify(this.searchcase)).subscribe(
            (response) => {
                this.data = response;
                this.isCompleted = true;
                this.totalRecord = this.data.length;
                this.hasError = false;
            },
            (error) => {                
                this.errorMessage = error.message;
                this.isCompleted = true;
                this.hasError = true;
            }
        );
        this.getSearchFields();
    }

    public onChange(pageEvent: any) {
        this.totalRecord = pageEvent.dataLength;
        this.rowsOnPage > 15 ? this.rowsOnPage = 10 : this.rowsOnPage = this.rowsOnPage;
    }

    public setCaseNumber(caseNumber: string) {
        this.currentCaseDisplayNumber = caseNumber;
    }

    public getSearchFields(): void {
        let casefield = new CaseSearchFields();
        this.searchFields.push(casefield);
        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery0";
        casefield.Name = "CaseNumber";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery1";
        casefield.Name = "FileNumber";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery2";
        casefield.Name = "LastName";
        this.searchFields.push(casefield);


        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery3";
        casefield.Name = "FirstName";
        this.searchFields.push(casefield);


        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery4";
        casefield.Name = "DOB";
        casefield.Type = "Date";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery5";
        casefield.Name = "Location";
        this.searchFields.push(casefield);

        casefield = new CaseSearchFields();
        casefield.Id = "filterQuery6";
        casefield.Name = "JudicialOfficer";
        this.searchFields.push(casefield);
    }

    public getSelectedField(id: string) {
        var obj = this.searchFields.find(n => n.Id === id);
        return obj;
    }
}

export class CaseSearchFields {
    public Id: string;
    public Name: string;
    public Type: string;
    constructor() {
        this.Id = "";
        this.Name = "--Select--";
        this.Type = "string";
    }
}
